import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Category from "./pages/Category";
import ListingDetail from "./pages/ListingDetail";
import PostListing from "./pages/PostListing";
import Auctions from "./pages/Auctions";
import AuctionDetail from "./pages/AuctionDetail";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Profile from "./pages/Profile";
import Search from "./pages/Search";
import Chat from "./pages/Chat";
import Admin from "./pages/Admin";
import AuthCallback from "./pages/AuthCallback";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import CookiePolicy from "./pages/CookiePolicy";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import UserProfile from "./pages/UserProfile";
import ChooseAccount from "./pages/ChooseAccount";
import RegisterBusiness from "./pages/RegisterBusiness";
import BusinessDashboard from "./pages/BusinessDashboard";
import Categories from "./pages/Categories";
import CookieBanner from "./components/CookieBanner";
import GrandOpening from "./components/GrandOpening";
import MobileBottomNav from "./components/MobileBottomNav";
import { AuthProvider } from "./context/AuthContext";

function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <Header />
      <main className="flex-1 pb-16 md:pb-0">{children}</main>
      <Footer />
      <MobileBottomNav />
    </div>
  );
}

// Intercept Emergent Google Auth redirect synchronously (during render, not in useEffect)
// to prevent race conditions with AuthProvider's /auth/me check.
function AppRouter() {
  const location = useLocation();
  if (location.hash && location.hash.includes("session_id=")) {
    return (
      <Layout>
        <AuthCallback />
      </Layout>
    );
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/categoria/:catId" element={<Category />} />
        <Route path="/annuncio/:id" element={<ListingDetail />} />
        <Route path="/pubblica" element={<PostListing />} />
        <Route path="/aste" element={<Auctions />} />
        <Route path="/asta/:id" element={<AuctionDetail />} />
        <Route path="/login" element={<Login />} />
        <Route path="/registrati" element={<Register />} />
        <Route path="/profilo" element={<Profile />} />
        <Route path="/cerca" element={<Search />} />
        <Route path="/messaggi" element={<Chat />} />
        <Route path="/messaggi/:cid" element={<Chat />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/termini" element={<Terms />} />
        <Route path="/cookie" element={<CookiePolicy />} />
        <Route path="/pagamento/successo" element={<PaymentSuccess />} />
        <Route path="/pagamento/annullato" element={<PaymentCancel />} />
        <Route path="/u/:uid" element={<UserProfile />} />
        <Route path="/scegli-account" element={<ChooseAccount />} />
        <Route path="/registrati-azienda" element={<RegisterBusiness />} />
        <Route path="/azienda/dashboard" element={<BusinessDashboard />} />
        <Route path="/categorie" element={<Categories />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <CookieBanner />
        <GrandOpening />
      </BrowserRouter>
      <Toaster />
    </AuthProvider>
  );
}

export default App;
